import { Routes } from '@angular/router';
import { authGuard, SPECTRUM_HELP_ROUTES } from 'common';

export const routes: Routes = [
    {
        path: 'validate',
        loadComponent: () => import('./validate/validate.component').then(m => m.ValidateComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('./layout/screens.component').then(m => m.ScreensComponent),
        children: [
            // The Help centre: this module's manual and Getting around Spectrum.
            ...SPECTRUM_HELP_ROUTES,
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadComponent: () => import('./screens/dashboard/dashboard.component').then(m => m.DashboardComponent)
            },
            {
                path: 'marks',
                loadComponent: () => import('./screens/marks-entry/marks-entry.component').then(m => m.MarksEntryComponent)
            },
            {
                path: 'schemes',
                loadComponent: () => import('./screens/schemes/schemes.component').then(m => m.SchemesComponent)
            },
            {
                path: 'schemes/new',
                loadComponent: () => import('./screens/scheme-builder/scheme-builder.component').then(m => m.SchemeBuilderComponent)
            },
            {
                path: 'schemes/:id',
                loadComponent: () => import('./screens/scheme-builder/scheme-builder.component').then(m => m.SchemeBuilderComponent)
            },
            {
                path: 'report-cards',
                loadComponent: () => import('./screens/report-cards/report-cards.component').then(m => m.ReportCardsComponent)
            },
            {
                path: 'co-scholastic',
                loadComponent: () => import('./screens/co-scholastic/co-scholastic.component')
                    .then(m => m.CoScholasticComponent)
            },
            {
                path: 'early-years',
                loadComponent: () => import('./screens/early-years/early-years.component')
                    .then(m => m.EarlyYearsComponent)
            },
            {
                path: 'report-remarks',
                loadComponent: () => import('./screens/report-remarks/report-remarks.component')
                    .then(m => m.ReportRemarksComponent)
            },
            {
                path: 'report-templates',
                loadComponent: () => import('./screens/report-templates/report-templates.component')
                    .then(m => m.ReportTemplatesComponent)
            },
            {
                path: 'report-templates/:id',
                loadComponent: () => import('./screens/report-template-builder/report-template-builder.component')
                    .then(m => m.ReportTemplateBuilderComponent)
            },
            {
                path: 'exam-schedule',
                loadComponent: () => import('./screens/exam-schedule/exam-schedule.component').then(m => m.ExamScheduleComponent)
            },
            {
                path: 'syllabus',
                loadComponent: () => import('./screens/syllabus/syllabus.component').then(m => m.SyllabusComponent)
            },
            {
                path: 'timetable',
                loadComponent: () => import('./screens/timetable/timetable.component').then(m => m.TimetableComponent)
            },
            {
                path: 'timetable/generate',
                loadComponent: () => import('./screens/timetable-generate/timetable-generate.component').then(m => m.TimetableGenerateComponent)
            },
            {
                path: 'timetable/setup',
                loadComponent: () => import('./screens/timetable-setup/timetable-setup.component').then(m => m.TimetableSetupComponent)
            },
            {
                path: 'analytics',
                loadComponent: () => import('./screens/analytics/analytics.component').then(m => m.AnalyticsComponent)
            },
            {
                path: 'subjects',
                loadComponent: () => import('./screens/subjects/subjects.component').then(m => m.SubjectsComponent)
            },
            {
                path: 'allocation',
                loadComponent: () => import('./screens/allocation/allocation.component').then(m => m.AllocationComponent)
            },
            // The section-at-a-time mapping screen this replaced. Kept as a
            // redirect: it is bookmarked, and two screens writing TEACHER_ID
            // would diverge.
            { path: 'teacher-mapping', redirectTo: 'allocation', pathMatch: 'full' },
            {
                path: 'academic-years',
                loadComponent: () => import('./screens/academic-years/academic-years.component').then(m => m.AcademicYearsComponent)
            },
            {
                path: 'calendar',
                loadComponent: () => import('./screens/calendar/calendar.component').then(m => m.CalendarComponent)
            },
            {
                path: 'calendar-setup',
                loadComponent: () => import('./screens/calendar-setup/calendar-setup.component')
                    .then(m => m.CalendarSetupComponent)
            },
            {
                path: 'week-offs',
                loadComponent: () => import('./screens/week-offs/week-offs.component').then(m => m.WeekOffsComponent)
            },
        ]
    },
    { path: '**', redirectTo: '' }
];
